export enum JoinSide {
    LEFT,
    RIGHT,
}
